/* eslint-disable */
import React, { useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import ExpandableListIllustration from '../../components/ExpandableListIllustration';
import ExpandableBubbleCards from '../../components/ExpandableBubbleCards';
import HighlightedCardsGrid from '../../components/HighlightedCardsGrid';
import eliIllustration from '../../../../../../assets/student-training/AIns/img2.png';
import { useUpdateComponentState } from '../../../hooks';
import Quiz from '../../components/Quiz';
import quizBg from '../../../../../../assets/student-training/AIns/quiz-bg.png';
import { HCG_Section3_ICONS } from './iconMap';
interface ISection3Props {
  settings: any;
}

const BUBBLE_ITEMS = [
  {
    title: '存取檔案及資料夾',
    content: '讀 取 文 件 、 圖\n片 、 下 載 內 容 或\n其 他 儲 存 資 料 。',
  },
  {
    title: '連接帳戶及平台',
    content:
      '連 接 電 郵 、 雲 端\n平 台 、 學 習 工 具\n或 其 他 網 上 服\n務 。',
  },
  {
    title: '使用裝置功能',
    content: '使 用 相 機 、 咪 高\n峰 、 位 置 或 通 知\n等 功 能 。',
  },
  {
    title: '保留連接或持續運作',
    content:
      '部 分 工 具 在 完\n成 單 一 操 作 後 ，\n仍 可 繼 續 保 留 存\n取 權 限 或 背 景 運\n作 。',
  },
];

const Section3: React.FunctionComponent<ISection3Props> = ({ settings }) => {
  const ID = '4';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[3],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();

  const { quiz } = paragraphsSettings ?? {};

  const handleBubbleCardsComplete = useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-AIns-section3-2'
    );
  }, [updateComponentState, p_course, p_topic]);

  const handleExpandableComplete = useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-AIns-section3-1'
    );
  }, [updateComponentState, p_course, p_topic]);

  const handleQuizComplete = useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-AIns-section3-question'
    );
  }, [updateComponentState, p_course, p_topic]);

  const section3Items =
    paragraphsSettings?.section3Items?.map((item: any, index: number) => ({
      title: item.title,
      content: item.content,
      icon: HCG_Section3_ICONS[index](false),
    })) ?? [];

  return (
    <div className="topic-section-3">
      <ExpandableListIllustration
        mainTitle={paragraphsSettings.title}
        subTitle={paragraphsSettings.section1Title}
        description={paragraphsSettings.section1Desc}
        illustration={<img src={eliIllustration} alt="" />}
        items={paragraphsSettings.section1Items}
        defaultOpenIndex={-1}
        id="student-training-AIns-section3-1"
        onComplete={handleExpandableComplete}
      />
      <ExpandableBubbleCards
        mainTitle={paragraphsSettings.section2Title}
        description={paragraphsSettings.section2Desc}
        items={paragraphsSettings.section2Items}
        id="student-training-AIns-section3-2"
        onComplete={handleBubbleCardsComplete}
      />

      <div style={{ margin: '8rem 0' }}>
        <HighlightedCardsGrid
          subTitle={paragraphsSettings.section3Title}
          description={paragraphsSettings.section3Desc}
          items={section3Items}
        />
      </div>
      <div id="student-training-AIns-section3-question" className="topic-quiz">
        <Quiz
          title={paragraphsSettings?.questionTitle ?? ''}
          description={quiz?.description ?? ''}
          question={quiz?.question ?? ''}
          options={quiz?.options ?? []}
          quizImg={quizBg}
          onCompleted={handleQuizComplete}
        />
      </div>
    </div>
  );
};

export default React.memo(Section3);
